import { ELabelColor, type IEtazhiBlackFridayDiscountColorsConfig } from 'shared/types/etazhiBlackFriday';

import { mapLabelBgColor, mapLabelColor } from './mapColors';

/**
 * Код появился к проекту "Чёрная пятница" для компании "Этажи".
 * @todo: удалить в задаче CD-251228
 */
export const getEtazhiBlackFridayPriceDiscountColors = (color: ELabelColor): IEtazhiBlackFridayDiscountColorsConfig => {
  return {
    bgColor: mapLabelBgColor(color),
    color: mapLabelColor(color),
    strikethroughColor: mapLabelBgColor(color),
  };
};
